import React from 'react'
import Header from "../components/Header"
import Menu from "../components/Menu"

const Home = () => {
    
    return (
        <div>
            <Menu />
        </div>
    )
}

export default Home